import { Loader } from '@mantine/core';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import IDA from '@assets/ida.gif';
import { Text } from '@components';
import { useStore } from '@stores';

export const LoadingPage: React.FC = () => {
  const { t } = useTranslation('common');
  const {
    initializeStore: { showGenericAnimation },
  } = useStore();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '3rem',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',

        '& > img': {
          width: '251px',
          height: '245px',
        },
      }}
    >
      {showGenericAnimation ? (
        <Loader color="blue" type="bars" size="lg" />
      ) : (
        <img src={IDA} alt="Loading" />
      )}
      <Text variant="h1">{t('loadingOptions')}</Text>
    </Box>
  );
};
